<template>
  <!-- dialog z podglądem resource'a -->
  <v-dialog v-model="dialogVisible" scrollable fullscreen>
    <resource-preview-venit v-if="true" :id="resourceId?.uuid" :vin="null"
      :autoSelectView="props.autoSelectView"
      :autoSelectPart="props.autoSelectPart"
      @closeDialog="closePreviewDialog" />
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import type { ResourceId } from '@/venit/services/model/techpubs-cms';
import ResourcePreviewVenit from '@/venit/components/cortona-venit/components/cortona/Model.vue';

const props = withDefaults(defineProps<{
  previewTitle: string;
  previewSrc: string;
  iframeStyle?: string;
  previewDialog: boolean;
  resourceId: ResourceId;
  autoSelectView?: string;
  autoSelectPart?: string;
}>(), {
  iframeStyle: 'height: 75vh; width: 85vw',
});

const emit = defineEmits<{
  closeDialog: [];
}>();

const dialogVisible = ref(false);

watch(() => props.previewDialog, (newValue) => { dialogVisible.value = newValue; }, { immediate: true });
watch(dialogVisible, (newValue) => { if (!newValue) closePreviewDialog(); });

const closePreviewDialog = () => emit('closeDialog');
</script>
